import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';

const ACTION_LABEL = {
  DISABLE: '禁用',
  MUTE: '禁言',
  NONE: '無處置',
};

const REASON_LABEL = {
  SPAM: '垃圾訊息',
  SCAM: '詐騙',
  HARASSMENT: '騷擾',
  SEXUAL_CONTENT: '色情',
  VIOLENCE: '暴力',
  IMPERSONATION: '冒充',
  ILLEGAL_CONTENT: '違法',
  OTHER: '其他',
};

export default function MemberViolationHistoryModal({ open, member, onClose }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !member?.id) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    adminApi
      .listImViolations(member.id)
      .then((data) => {
        if (!cancelled) setRows(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || '載入失敗');
          setRows([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, member?.id]);

  if (!open) return null;

  return (
    <div className="confirm-dialog-overlay" role="presentation" onClick={onClose}>
      <div
        className="modal-panel modal-panel--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-panel__header">
          <h3>
            違規歷史紀錄 — {member?.username || member?.nickname || member?.id}
          </h3>
        </div>
        {loading ? <p>載入中…</p> : null}
        {error ? <p className="form-error">{error}</p> : null}
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>處置時間</th>
                <th>處置</th>
                <th>禁言</th>
                <th>檢舉原因</th>
                <th>檢舉人</th>
                <th>案件狀態</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.createTime || '—'}</td>
                  <td>{ACTION_LABEL[row.actionType] || row.actionType}</td>
                  <td>
                    {row.actionType === 'MUTE'
                      ? row.muteDays
                        ? `${row.muteDays} 天（至 ${row.muteUntil || '—'}）`
                        : `永久（至 ${row.muteUntil || '—'}）`
                      : '—'}
                  </td>
                  <td>
                    {row.reportId
                      ? `${REASON_LABEL[row.reportReason] || row.reportReason || '—'} (#${row.reportId})`
                      : '—'}
                  </td>
                  <td>
                    {row.reporterUsername
                      ? `${row.reporterUsername}（${row.reporterMemberId}）`
                      : row.reporterMemberId || '—'}
                  </td>
                  <td>{row.reportStatus || '—'}</td>
                  <td>{row.adminNote || row.reportDescription || '—'}</td>
                </tr>
              ))}
              {!loading && !rows.length ? (
                <tr>
                  <td colSpan={7}>尚無違規紀錄</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        <div className="modal-panel__footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
